import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const MiscError = () => {
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#F5F7FA' }}>
      <Result
        status="404"
        title="Page non trouvee"
        subTitle="Oups ! L'URL demandee n'a pas ete trouvee sur ce serveur."
        extra={
          <Button
            type="primary"
            onClick={() => navigate('/dashboard')}
            style={{
              borderRadius: 8,
              backgroundColor: '#C8102E',
              border: 'none',
              height: 44,
              paddingLeft: 24,
              paddingRight: 24,
            }}
          >
            Retour au tableau de bord
          </Button>
        }
      />
    </div>
  );
};

export default MiscError;
